<template>
    <li @click="$refs.imgupload.click()">
        <a href="javascript:void(0)"><em class="icon ni ni-camera-fill"></em> <span>Change Photo</span></a>
        <input ref="imgupload" hidden type="file" accept="image/*" @change="uploadImage('onClick')" id="file-input">
    </li>
</template>

<script>
    export default {
        props: ["path"],
        data: function () {
            return {
                image: '../../images/Placeholder.svg',
                data: [],
                url: '',
            }
        },
        methods: {
            uploadImage() {
                var root = this;
                var file = this.$refs.imgupload.files;
                this.filePath = null;
                var fileData = new FormData();
                this.image = URL.createObjectURL(this.$refs.imgupload.files[0]);
                // convert file into FormData object
                for (var k = 0; k < file.length; k++) {
                    fileData.append("files", file[k]);
                }

                this.$https.post('/Company/UploadFilesAsync', fileData)
                    .then(function (response) {
                        if (response.data != null) {
                            root.$emit('picPath', response.data);                            
                        }
                    });
            },

            

        },

        mounted: function () {
            
        }
    }
</script>

